import { FormToggle, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useToggleSocSimAccessMutation, useUpdateApiKeysStatusMutation, useUpdateCustomPathsStatusMutation } from '../../corporate.slice';
import { StyledSidePanelFormToggleRow, StyledSidePanelText } from '../../corporate.styles';
import { AllowedToggleModes, type ToggleRowProps } from '../../corporate.types';
export const Toggler = ({
  companyId,
  toggleStatus,
  mode,
  children,
  ...nativeLabelProps
}: ToggleRowProps) => {
  const [toggleApiKey] = useUpdateApiKeysStatusMutation();
  const [toggleCustomPath] = useUpdateCustomPathsStatusMutation();
  const [toggleSocSim] = useToggleSocSimAccessMutation();
  const handleToggleApiKeys = async (status: string) => {
    try {
      await toggleApiKey({
        companyId,
        status
      }).unwrap();
      NotificationDispatch('success', 'API key access toggled.');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  const handleToggleCustomPath = async (status: string) => {
    try {
      await toggleCustomPath({
        companyId,
        status
      }).unwrap();
      NotificationDispatch('success', 'Custom path access toggled.');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  const handleToggleSocSim = async () => {
    try {
      await toggleSocSim({
        companyId
      }).unwrap();
      NotificationDispatch('success', 'SOC Simulator access toggled.');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  const handleToggleClick = () => {
    switch (mode) {
      case AllowedToggleModes.API_KEYS:
        {
          return handleToggleApiKeys(toggleStatus ? 'disable' : 'enable');
        }
      case AllowedToggleModes.PATHS:
        {
          return handleToggleCustomPath(toggleStatus ? 'disable' : 'enable');
        }
      case AllowedToggleModes.SOC_SIM:
        {
          return handleToggleSocSim();
        }
      default:
        {
          return NotificationDispatch('warning', 'Attempted to use toggle with an unsupported mode');
        }
    }
  };
  const labelId = `toggle-label-${mode}`;
  return <StyledSidePanelFormToggleRow {...nativeLabelProps} data-sentry-element="StyledSidePanelFormToggleRow" data-sentry-component="Toggler" data-sentry-source-file="toggler.tsx">
      <StyledSidePanelText id={labelId} data-sentry-element="StyledSidePanelText" data-sentry-source-file="toggler.tsx">{children}</StyledSidePanelText>
      <FormToggle checked={toggleStatus ?? false}
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onClick={handleToggleClick} aria-labelledby={labelId} data-sentry-element="FormToggle" data-sentry-source-file="toggler.tsx" />
    </StyledSidePanelFormToggleRow>;
};